<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="situacaoAtendimentoPlace.descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  data-cy="descricao-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-descricao-validate"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="situacaoAtendimentoPlace.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="situacaoAtendimentoPlace.ativo"
                :checked="situacaoAtendimentoPlace.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ situacaoAtendimentoPlace.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('situacaoAtendimentoSettingsModule', {
      situacaoAtendimento: state => state.situacaoAtendimento,
    }),
    canInsert() {
      return this.verificarPermissao('ROLE_SITUACAO_ATENDIMENTO_INSERIR')
    },
    canEdit() {
      return this.verificarPermissao('ROLE_SITUACAO_ATENDIMENTO_ATUALIZAR')
    },
    canEditOrInsert() {
      if (this.situacaoAtendimentoPlace.id) {
        return this.canEdit
      }
      return this.canInsert
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: 'Cadastro de Situação de Atendimento',
      required,
      situacaoAtendimentoPlace: {
        descricao: '',
        ativo: true,
      },
    }
  },
  mounted() {
    this.situacaoAtendimentoPlace = JSON.parse(JSON.stringify(this.situacaoAtendimento))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('situacaoAtendimentoSettingsModule/resetSituacaoAtendimento')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.situacaoAtendimentoPlace.id) {
            this.$store.dispatch('situacaoAtendimentoSettingsModule/editSituacaoAtendimento', this.situacaoAtendimentoPlace).then(response => {
              if (response.response) {
                this.MensagemError('Falha ao Editar', response.response.data.error)
                return
              }
              this.showMessageSuccess('Editar', 'Editado com sucesso!')
              this.$refs.form.reset()
              this.cancel()
            })
          } else {
            this.$store.dispatch('situacaoAtendimentoSettingsModule/insertNewSituacaoAtendimento', this.situacaoAtendimentoPlace).then(response => {
              if (response.response) {
                this.MensagemError('Falha ao Inserir', response.response.data.error)
                return
              }
              this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
              this.cleanObjeto()
              this.$refs.form.reset()
            })
          }
        }
      })
    },
    cleanObjeto() {
      this.situacaoAtendimentoPlace = {
        descricao: '',
        ativo: true,
      }
    },
  },
}
</script>
